import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Download, Lock } from 'lucide-react';
const KIT_URL = 'https://digital-solvex-ar.myshopify.com/cart/48566694772993:1';
const KIT_IMG = 'https://cdn.shopify.com/s/files/1/0815/5253/9905/files/A_premium_collection_202604161700.jpg?v=1776373446';
const PAYMENT_METHODS = [{
  label: 'Mercado Pago',
  short: 'MP',
  bg: '#009EE3',
  color: '#fff'
}, {
  label: 'Visa',
  short: 'VISA',
  bg: '#1A1F71',
  color: '#fff'
}, {
  label: 'Mastercard',
  short: 'MC',
  bg: '#252525',
  color: '#EB001B'
}, {
  label: 'Amex',
  short: 'AMEX',
  bg: '#006FCF',
  color: '#fff'
}, {
  label: 'Débito',
  short: 'DÉBITO',
  bg: '#243447',
  color: '#aaa'
}, {
  label: 'Transferencia',
  short: 'TRANSF.',
  bg: '#243447',
  color: '#aaa'
}];
export function HeroSection() {
  return <section className="bg-navy-mid dot-bg pt-12 md:pt-20 pb-16 md:pb-24 px-4" data-id="element-103">
      <div className="max-w-6xl mx-auto" data-id="element-104">
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center" data-id="element-105">

          {/* ── LEFT COPY ── */}
          <motion.div initial={{
          opacity: 0,
          y: 36
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.65
        }} data-id="element-106">
            {/* Trust badge */}
            <div className="inline-flex items-center gap-2 bg-teal/10 border border-teal/30 rounded-full px-4 py-1.5 mb-6" data-id="element-107">
              <span className="w-2 h-2 rounded-full bg-teal animate-pulse flex-shrink-0" data-id="element-108" />
              <span className="text-xs font-bold text-teal tracking-wider uppercase" data-id="element-109">
                +500 profesionales ya cobran en dólares y están blindados ante ARCA
              </span>
            </div>

            {/* Headline */}
            <h1 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.06] text-white mb-5" data-id="element-110">
              Cobrá en{' '}
              <span className="gold-shine" data-id="element-111">dólares reales</span>
              {' '}y blindate ante ARCA — el sistema completo para el profesional argentino
            </h1>

            <p className="text-white/60 text-base md:text-lg leading-relaxed mb-8 max-w-lg" data-id="element-112">
              Aprendé a cobrar en dólares desde Argentina, organizá tus finanzas y operá con tranquilidad ante ARCA — todo en un solo kit de descarga inmediata.
            </p>

            {/* Stats row — 2x2 on mobile, 4-col on desktop */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-2.5 mb-8" data-id="element-113">
              {[{
              n: '+500',
              l: 'Profesionales'
            }, {
              n: '5',
              l: 'Productos'
            }, {
              n: '100%',
              l: 'Legal'
            }].map(({
              n,
              l
            }) => <div key={l} className="bg-white/[0.045] border border-white/[0.07] rounded-xl py-3 px-2 text-center" data-id="element-114">
                  <div className="font-display text-xl md:text-2xl text-gold leading-none mb-1" data-id="element-115">{n}</div>
                  <div className="text-[9px] text-white/35 uppercase tracking-widest" data-id="element-116">{l}</div>
                </div>)}
            </div>

            {/* CTA Button */}
            <a href={KIT_URL} className="btn-gold block text-center font-display text-base md:text-lg px-6 py-4 rounded-xl mb-5 no-underline" data-id="element-117">
              Quiero el Kit Completo por $62.900 →
            </a>

            {/* Trust strip — 3 cards */}
            <div className="grid grid-cols-3 gap-2 mb-8" data-id="element-118">
              {[{
              Icon: Lock,
              label: 'Pago seguro',
              sub: 'Mercado Pago'
            }, {
              Icon: Download,
              label: 'Descarga inmediata',
              sub: 'Al instante'
            }, {
              Icon: ShieldCheck,
              label: 'Garantía 7 días',
              sub: 'Sin preguntas'
            }].map(({
              Icon,
              label,
              sub
            }) => <div key={label} className="flex flex-col items-center text-center bg-white/[0.04] border border-white/[0.07] rounded-xl py-3 px-2 gap-1.5" data-id="element-119">
                  <div className="w-8 h-8 rounded-lg bg-teal/15 border border-teal/25 flex items-center justify-center" data-id="element-120">
                    <Icon className="w-4 h-4 text-teal" data-id="element-121" />
                  </div>
                  <span className="text-[11px] font-bold text-white/80 leading-tight" data-id="element-122">{label}</span>
                  <span className="text-[9px] text-white/30" data-id="element-123">{sub}</span>
                </div>)}
            </div>

            {/* Mercado Pago badges — properly spaced */}
            <div className="border-t border-white/[0.06] pt-5" data-id="element-124">
              <p className="text-[10px] text-white/30 uppercase tracking-widest mb-3" data-id="element-125">
                Aceptamos todos los medios de pago
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-126">
                {PAYMENT_METHODS.map(({
                short,
                bg,
                color
              }) => <span key={short} className="text-[10px] font-extrabold px-2.5 py-1.5 rounded-md tracking-wider flex-shrink-0" style={{
                background: bg,
                color
              }} data-id="element-127">
                    {short}
                  </span>)}
              </div>
            </div>
          </motion.div>

          {/* ── RIGHT: PRODUCT IMAGE (square-safe) ── */}
          <motion.div initial={{
          opacity: 0,
          x: 40
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.75,
          delay: 0.2
        }} className="relative flex items-center justify-center" data-id="element-128">
            {/* Glow */}
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-129">
              <div className="w-4/5 h-4/5 bg-gold/10 rounded-full blur-3xl" data-id="element-130" />
            </div>

            {/* Image wrapper — handles any aspect ratio gracefully */}
            <div className="relative z-10 w-full max-w-sm md:max-w-none" data-id="element-131">
              {/* Floating badges */}
              <div className="absolute top-4 right-4 z-20 bg-gold text-navy-dark font-display text-xs font-extrabold px-3 py-1.5 rounded-full shadow-lg shadow-gold/30" data-id="element-132">
                $62.900 hoy
              </div>
              <div className="absolute top-12 right-4 z-20 bg-teal text-white text-[10px] font-bold px-2.5 py-1.5 rounded-full" data-id="element-133">
                Ahorrás $216.600
              </div>

              <img src={KIT_IMG} alt="Kit Blindaje Total Argentina — 5 productos" className="w-full rounded-2xl shadow-2xl" style={{
              display: 'block'
            }} data-id="element-134" />
            </div>
          </motion.div>

        </div>
      </div>
    </section>;
}